import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography,
	styled
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { Image, Label } from 'components';
import { useMenu } from 'hooks';
import { CATEGORIES, POSITIONS } from 'lib/constants';

const LabelContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column'
}));

const LabelItem = styled(Box)(({ theme }) => ({
	marginBottom: theme.spacing(0.5)
}));

const CourseItem = ({
	course,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(course, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(course, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(course.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(course)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(course)}
						name="course"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={course.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="body2">{course.title}</Typography>
			</TableCell>
			<TableCell>
				<LabelContainer>
					{course.categories.map((c, i) => (
						<LabelItem key={i}>
							<Label label={CATEGORIES.find((v) => v.value == c)?.label || c} />
						</LabelItem>
					))}
				</LabelContainer>
			</TableCell>
			<TableCell>
				<LabelContainer>
					{course.positions.map((p, i) => (
						<LabelItem key={i}>
							<Label label={POSITIONS.find((v) => v.value == p)?.label || p} />
						</LabelItem>
					))}
				</LabelContainer>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{course.trainer?.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">
					{course.featured ? 'Yes' : 'No'}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">
					{course.published ? 'Yes' : 'No'}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">
					{course.recommended ? 'Yes' : 'No'}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{course.premium ? 'Yes' : '-'}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default CourseItem;
